import { render, staticRenderFns } from "./ProductDocuments.vue?vue&type=template&id=b86a9130&"
import script from "./ProductDocuments.vue?vue&type=script&lang=js&"
export * from "./ProductDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports